const targetParser: any = {};

targetParser.getTabs = (response: any) => {
  let tabsData = [];
  let totalTabsCount = 0;

  if (response.success && Array.isArray(response.data)) {
    tabsData = response.data;
    totalTabsCount = 0;
  }

  // Function to format dates
  const formatDate = (apiDate: string): string => {
    const date = new Date(apiDate);
    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    return date.toLocaleDateString("en-GB", options).replace(",", "");
  };

  const tabs = tabsData?.map((tab: any) => ({
    categories: tab.categories || "-",
    tabDetails:
      tab.tabDetails?.map((tabDetail: any) => ({
        tabId: tabDetail.targetAchievementTabId || "-",
        tabName: tabDetail.tabName || "-",
        isActive: tabDetail.isActive || false,
        createdAt: formatDate(tabDetail.createdAt || "-"),
        updatedAt: formatDate(tabDetail.updatedAt || "-"),
        publishedAt: formatDate(tabDetail.publishedAt || "-"),
        isApproved: tabDetail.isApproved,
        parameterFields:
          tabDetail.parameterFields?.map((field: any) => ({
            id: field.tabId || "-",
            name: field.name || "-",
            valueType: field.valueType || "STRING",
          })) || [],
      })) || [],
  }));

  return {
    allTabs: tabs,
    totalTabs: totalTabsCount,
  };
};

targetParser.getTargetAchievement = (response: any) => {
  let tabsData = [];
  let totalTableDataCount = 0;
  let isApprovedKey = false;

  // Check if the response is successful and rows are available
  if (response.success && Array.isArray(response.data.rows)) {
    tabsData = response.data.rows;
    totalTableDataCount = response.data.rowsCount;
    isApprovedKey = response?.data.isApproved;
  }

  const tabs = tabsData?.map((tab: any) => ({
    targetAchievementId: tab.targetAchievementId || "-",
    parameters: tab.parameters || [],
  }));

  if (response.data?.filePath) {
    return response.data;
  }

  return {
    tableData: tabs,
    tableDataRowCount: totalTableDataCount,
    isApproved: isApprovedKey,
  };
};

targetParser.getTableHeaderDataById = (response: any) => {
  if (!response || !response.success || !response.data) {
    throw new Error("Invalid or unsuccessful response");
  }

  const { targetAchievementTabId, tabName, parameterFields } = response.data;

  if (!parameterFields || !Array.isArray(parameterFields)) {
    throw new Error("Parameter fields are missing or invalid");
  }

  const headers = Object.entries(parameterFields[0]).map(
    ([key, valueType]) => ({
      id: key.replace(/\s/g, ""),
      name: key,
      valueType,
    })
  );

  return {
    tabId: targetAchievementTabId,
    tabName,
    headers,
  };
};

export default targetParser;
